import { Content } from '../../types';

export const angkorTemplesContent: Content = {
  title: 'מקדשי אנגקור - הפלא הארכיאולוגי של קמבודיה',
  imageUrl: 'https://tinyurl.com/angkor-temple-wide',
  introduction: `אנגקור, הינה אחת הערים המרשימות ביותר בהיסטוריה האנושית ומהווה את אחד מאתרי התיירות המפורסמים בעולם. מתחם המקדשים העצום, שנבנה בין המאה ה-9 למאה ה-15 לספירה, מהווה עדות מרהיבה לעוצמתה של האימפריה הקמרית ולגאונות האדריכלית של בוניה.`,
  sections: [
    {
      title: 'היסטוריה ואדריכלות',
      content: `האימפריה הקמרית הייתה אחת התרבויות המתקדמות ביותר בזמנה, והשאירה אחריה מורשת אדריכלית מרשימה. המקדשים באנגקור נבנו כחלק ממערך עירוני מתוחכם, שכלל מערכות השקיה מתקדמות ותכנון עירוני מדויק. האדריכלות משלבת אלמנטים הינדואיסטיים ובודהיסטיים, עם דגש על סימטריה והרמוניה עם הסביבה הטבעית.`,
      type: 'text',
    },
    {
      title: 'המקדשים המרכזיים של אנגקור',
      content: [
        {
          subtitle: 'אנגקור ואט (Angkor Wat)',
          text: 'המקדש המפורסם והגדול ביותר במתחם, המסמל את שיא ההישגים האדריכליים של האימפריה הקמרית. המקדש נבנה במאה ה-12 כמקדש הינדואיסטי המוקדש לאל וישנו. המבנה המרכזי מתנשא לגובה של 65 מטרים ומוקף בחומה ותעלת מים. התבליטים המפורטים על הקירות מספרים סיפורים מהמיתולוגיה ההינדואיסטית.',
        },
        {
          subtitle: 'אנגקור תום (Angkor Thom)',
          text: 'העיר המבוצרת האחרונה והגדולה של האימפריה הקמרית. שטחה כ-9 קמ"ר והיא מוקפת חומה וחפיר. בכל אחד מארבעת שעריה המרשימים מוצבים פסלי ענק של פני אלים ודמונים.',
        },
        {
          subtitle: 'באיון (Bayon)',
          text: 'המקדש המרכזי של אנגקור תום, המפורסם בזכות 54 המגדלים שלו, שעל כל אחד מהם חקוקים ארבעה פרצופים ענקיים. המקדש מייצג את המעבר מהינדואיזם לבודהיזם באימפריה הקמרית.',
        },
        {
          subtitle: 'טא פרום (Ta Prohm)',
          text: 'מקדש שהושאר במכוון במצבו הטבעי, כאשר עצי הענק והשורשים שלהם משתלבים במבנים. המקדש מדגים את הקשר המיוחד בין הטבע לאדריכלות באנגקור.',
        },
        {
          subtitle: 'פנום בקנג (Phnom Bakheng)',
          text: 'מקדש-הר מהמאה ה-9, הממוקם על גבעה טבעית. מקום פופולרי לצפייה בשקיעה מעל אנגקור ואט, אך יש להגיע מוקדם בשל מגבלת המבקרים.',
        },
        {
          subtitle: 'פרה קאן (Preah Khan)',
          text: 'מקדש גדול שהיה גם מרכז דתי וגם אוניברסיטה. המבנה המורכב כולל מסדרונות ארוכים, מקדשים קטנים ופסלים רבים.',
        },
        {
          subtitle: 'בנטאי סריי (Banteay Srei)',
          text: 'מקדש קטן יחסית אך מפורסם בזכות התבליטים המפורטים והמדויקים שלו, שנחשבים ליפים ביותר באנגקור. המקדש נבנה מאבן חול ורודה וממוקם כ-25 ק"מ מהמתחם המרכזי.',
        },
      ],
      type: 'list',
    },
    {
      title: 'דרכי הגעה והמלצות לביקור',
      content: `האתר נמצא כ-10 ק"מ צפונית לעיר סיאם ריפ, המשמשת כבסיס לטיולים באזור. ניתן להגיע למתחם במונית, טוק-טוק או אופניים. מומלץ לשכור מדריך מקומי מוסמך שיכול להסביר על ההיסטוריה והמשמעות של כל מקדש.
הכרטיסים נמכרים ל-1, 3 או 7 ימים, כאשר רוב המטיילים בוחרים בכרטיס ל-3 ימים המאפשר סיור מקיף אך לא מלחיץ. חשוב לזכור שהאקלים חם ולח, ולכן מומלץ להתחיל את הסיורים מוקדם בבוקר ולקחת הפסקות במהלך היום.`,

      type: 'text-image',
      imageUrl: 'https://tinyurl.com/angkor-temple-article-1',
    },
    {
      title: 'טיפים לביקור',
      content: [
        'הגיעו לזריחה באנגקור ואט - חוויה בלתי נשכחת, אך הגיעו מוקדם לתפוס מקום טוב',
        'לבשו בגדים צנועים - זהו אתר דתי פעיל',
        'הצטיידו בהרבה מים, כובע וקרם הגנה',
        'תכננו את המסלול מראש - המתחם עצום והמרחקים גדולים',
        'קחו הפסקות במהלך היום - החום והלחות מתישים',
        'הביאו מצלמה טובה - הנופים והמקדשים מרהיבים',
        'שקלו לשכור אופניים לסיור עצמאי בין המקדשים',
        'בקרו במקדשים המרוחקים יותר בשעות אחר הצהריים כשפחות תיירים',
      ],
      type: 'list',
    },
    {
      title: 'סיכום',
      content: `מקדשי אנגקור הם הרבה יותר מאשר אתר תיירות - הם עדות מרהיבה לתרבות עשירה ומתוחכמת שפרחה בדרום-מזרח אסיה. הביקור במקום הוא חוויה בלתי נשכחת המשלבת היסטוריה, אדריכלות, טבע ורוחניות. למרות התיירות הרבה, המקום עדיין שומר על קסמו המיוחד ומצליח להפתיע ולרגש כל מבקר מחדש.`,
      type: 'text',
    },
  ],
};
